document.addEventListener("DOMContentLoaded", function() {
    const section = document.querySelector(".static-wrapper");
    const wrapper = section.querySelector(".carousel-wrapper");
    const track = section.querySelector(".carousel-track");
    const imageWrapper = section.querySelector('.carousel-button-wrapper');
    const prevBtn = imageWrapper?.querySelector(".carousel-btn.prev");
    const nextBtn = imageWrapper?.querySelector(".carousel-btn.next");

    if (!track || !wrapper || !prevBtn || !nextBtn) return;

    const MOBILE_BREAKPOINT = 1024;
    const items = track.querySelectorAll(".static-card");
    const scrollAmount = window.innerWidth <= MOBILE_BREAKPOINT ? 1 : 2;
    const visibleCardsNumber = window.innerWidth <= MOBILE_BREAKPOINT ? 1 : 3;
    let isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    let videoObserver = null;
    const backgroundVideos = document.querySelectorAll('.static-card-video-bg video');

    function setVisibleCards() {
        const gap = parseInt(getComputedStyle(track).gap);
        const wrapperWidth = wrapper.offsetWidth;
        const itemWidth = (wrapperWidth - gap * (visibleCardsNumber - 1)) / visibleCardsNumber;

        items.forEach(item => {
            item.style.flex = `0 0 ${itemWidth}px`;
            item.style.width = `${itemWidth}px`;
        });
    }

    function getItemWidth() {
        const gap = parseInt(getComputedStyle(track).gap);
        return items[0].offsetWidth + gap;
    }

    function updateButtons() {
        prevBtn.disabled = wrapper.scrollLeft === 0;
        nextBtn.disabled = Math.ceil(wrapper.scrollLeft + wrapper.offsetWidth) >= wrapper.scrollWidth;
    }

    nextBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: getItemWidth()*scrollAmount, behavior: 'smooth' });
        setTimeout(updateButtons, 300);
    });

    prevBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: -getItemWidth()*scrollAmount, behavior: 'smooth' });
        setTimeout(updateButtons, 300);
    });

    window.addEventListener("resize", () => {
        setVisibleCards();
        updateButtons();
    });

    setVisibleCards();
    updateButtons();

    backgroundVideos.forEach(video => {
        if (video.hasAttribute('autoplay')) {
            const originalPause = video.pause;
            video.pause = function() {
                if (!isMobile || (isMobile && !video.parentElement.closest('.static-card').hasAttribute('data-out-of-view'))) {
                    return;
                }
                return originalPause.apply(video, arguments);
            };
        }
    });

    function setupVideoAutoplay() {
        if (videoObserver) {
            videoObserver.disconnect();
            videoObserver = null;
        }

        if (isMobile && items.length > 0) {
            videoObserver = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach(entry => {
                        const card = entry.target;
                        const video = card.querySelector('.static-card-video-bg video');

                        if (!video || !video.hasAttribute('autoplay')) return;

                        if (entry.isIntersecting) {
                            video.muted = true;
                            video.setAttribute('playsinline', '');
                            card.removeAttribute('data-out-of-view');
                            video.play().catch(() => {});
                        } else {
                            if (!video.paused) {
                                card.setAttribute('data-out-of-view', 'true');
                                video.pause();
                            }
                        }
                    });
                },
                {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.5
                }
            );

            items.forEach(card => {
                if (card.querySelector('.static-card-video-bg video')) {
                    videoObserver.observe(card);
                }
            });
        } else if (!isMobile) {
            backgroundVideos.forEach(video => {
                if (video.hasAttribute('autoplay')) {
                    video.muted = true;
                    video.play().catch(() => {});
                }
            });
        }
    }

    setupVideoAutoplay();
});